export const LOCALE_PREFIX = 'scenes.Gnosus.scenes.Report.components.Workspace.components.Blocks.Addresses'
export const SET_IS_SCROLLED = 'SET_IS_SCROLLED'
